import Api from '@/utils/api'
import BasicConfig from '@/config/basic'

// 获取 产康当日完成率
export function getPostpartumCareCompletionRate (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/customers/completion_rate/maternityCare`, { params: { ...query, axiosType: 'python' } })
}
// 获取 产康完成率明细
export function getPostpartumCareCompletionRateDetail (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/customers/completion_rate/maternityCare_profile`, { params: { ...query, axiosType: 'python' } })
}

// 获取 护理部当日完成率
export function getNursingCareCompletionRate (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/customers/completion_rate/nursing`, { params: { ...query, axiosType: 'python' } })
}
// 获取 护理部完成率明细
export function getNursingCareCompletionRateDetail (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/customers/completion_rate/nursing_profile`, { params: { ...query, axiosType: 'python' } })
}

// 获取 客房当日完成率
export function getHousekeepingCompletionRate (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/customers/completion_rate/housekeeping`, { params: { ...query, axiosType: 'python' } })
}
// 获取 客房完成率明细
export function getHousekeepingCompletionRateDetail (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/customers/completion_rate/housekeeping_profile`, { params: { ...query, axiosType: 'python' } })
}

// 获取 餐饮当日完成率
export function getCateringCompletionRate (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/customers/completion_rate/catering`, { params: { ...query, axiosType: 'python' } })
}
// 获取 餐饮完成率明细
export function getCateringCompletionRateDetail (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/customers/completion_rate/catering_profile`, { params: { ...query, axiosType: 'python' } })
}

// 获取 到家当日完成率
export function getHomeServiceCompletionRate (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/customers/completion_rate/homeBabyCare`, { params: { ...query, axiosType: 'python' } })
}
// 获取 到家完成率明细
export function getHomeServiceCompletionRateDetail (query) {
  return Api.get(`${BasicConfig.szMysqlDomain}/api/customers/completion_rate/homeBabyCare_profile`, { params: { ...query, axiosType: 'python' } })
}
